import { useData, useDispatch } from "./DataContext.js";
import { setSimParam, getSimParam } from "./utils.js";

import { BellFill, BellSlash } from "react-bootstrap-icons";

import ToggleButton from "react-bootstrap/ToggleButton";

export default function CallButton (props)
{
    const gData = useData();
    const gDispatch = useDispatch();

    let pauseIDS = JSON.parse(getSimParam(gData, "pauseIDS"));
    if (pauseIDS === null) pauseIDS = [];

    const groupID = props.groupID;
    const group = gData.group[groupID];
    const groupTitle = group.title;

    function handlePause ()
    {
	if (pauseIDS.includes(props.groupID)) setSimParam(gData, gDispatch, "pauseIDS", JSON.stringify(pauseIDS.filter(id => id !== props.groupID)));
	else setSimParam(gData, gDispatch, "pauseIDS", JSON.stringify([ ...pauseIDS, props.groupID ]));
    }

    return (
	<ToggleButton
	    type="radio"
	    variant={props.variant}
	    checked={pauseIDS.includes(props.groupID)}
	    size={props.size}
	    onClick={handlePause}
	>
	    {pauseIDS.includes(props.groupID) ? (<BellFill/>) : (<BellSlash/>)} <span className="text-uppercase">{groupTitle}</span>
	</ToggleButton>
    );
}

CallButton.defaultProps = {
    variant: "outline-primary",
    size: "md"
};
